import { isNil } from "lodash";
import { useNotifyContentDetails } from "../../../../../hooks/useNotifyContent";
import { NotifyNotificationsTemplates } from "../create-from-template/constants/NotifyNotificationsTemplates";
import { NotifyTopNav } from "../../../../../components/NotifyTopNav";
import { Breadcrumb, Segment } from "semantic-ui-react";
import { NotifyNotificationsStatusLabel } from "../notifications/components/NotifyNotificationsStatusLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/pro-solid-svg-icons";
import { StyledReactMarkdown } from "../../../../../../../components/StyledReactMarkdown";

export function NotifyNotificationsCreate({}: {}) {
  const searchParams = new URLSearchParams(window.location.search);
  const templateType = searchParams.get("template-type") as "template" | "notification" | null;
  const templateId = searchParams.get("template-id");
  const parsedTemplateId = templateId ? parseInt(templateId) : null;

  const { notifyContent } = useNotifyContentDetails({
    enabled: templateType === "notification",
    id: parsedTemplateId,
  });

  const template =
    templateType === "template" && !isNil(parsedTemplateId) ? NotifyNotificationsTemplates[parsedTemplateId] : null;

  const body = notifyContent?.body || template?.template.body || "";

  return (
    <div className='tw-relative'>
      <div className='tw-sticky tw-top-0 tw-z-50'>
        <NotifyTopNav />
        <Segment attached='top' className='tw-mt-0 tw-rounded-none tw-border-x-0 tw-px-7 tw-py-3 tw-shadow-md'>
          <div className='tw-flex tw-items-center tw-gap-3'>
            <h1 className='tw-m-0 tw-text-2xl'>My Notification</h1>
            <NotifyNotificationsStatusLabel type='Draft' />
          </div>
        </Segment>
        <Segment attached='bottom' className='tw-mt-0 tw-rounded-none tw-border-x-0 tw-px-7 tw-py-3 tw-shadow-md'>
          <Breadcrumb>
            <Breadcrumb.Section>
              <div className='tw-flex tw-gap-1'>
                <FontAwesomeIcon icon={faPen} />
                <span>Edit</span>
              </div>
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon='right chevron' className='-tw-mt-3' />
            <Breadcrumb.Section>
              <div className='tw-flex tw-gap-1'>
                <FontAwesomeIcon icon={faPen} />
                <span>Edit</span>
              </div>
            </Breadcrumb.Section>
          </Breadcrumb>
        </Segment>
      </div>
      <Segment className='tw-m-7'>
        <StyledReactMarkdown>{body}</StyledReactMarkdown>
      </Segment>
    </div>
  );
}
